import React, { useEffect, useMemo, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom";

import NumberInputFormControl from "../../../shared/form-controls/NumberInputFormControl";
import TextInputFormControl from "../../../shared/form-controls/TextInputFormControl";

function ExceptionCategoryForm({ formData, submitForm }) {
  const history = useHistory();
  const { handleSubmit, control, reset } = useForm({
    defaultValues: useMemo(() => formData, [formData]),
  });

  useEffect(() => {
    reset(formData);
  }, [formData]);

  //======================================

  return (
    <form onSubmit={handleSubmit(submitForm)} className="w-100" noValidate>
      <div className="container" style={{ textAlign: "initial" }}>
        <div className="row justify-content-md-center">
          <div className="col-md">
            <Controller
              control={control}
              name="exception_Deco"
              rules={{ required: true }}
              render={({
                field: { onChange, value, name },
                fieldState: { error },
              }) => (
                <TextInputFormControl
                  label="Exception Deco"
                  placeholder="Exception Deco"
                  required
                  name={name}
                  value={value}
                  onChange={onChange}
                  error={error}
                />
              )}
            />

            <Controller
              control={control}
              name="exception_Pcat"
              rules={{ required: true }}
              render={({
                field: { onChange, value, name },
                fieldState: { error },
              }) => (
                <TextInputFormControl
                  label="Exception PCat"
                  placeholder="Exception PCat"
                  required
                  name={name}
                  value={value}
                  onChange={onChange}
                  error={error}
                />
              )}
            />

            <Controller
              control={control}
              name="startingColorCount"
              rules={{ required: true }}
              render={({
                field: { onChange, value, name },
                fieldState: { error },
              }) => (
                <NumberInputFormControl
                  label="Starting Color Count"
                  placeholder="Starting Color Count"
                  required
                  min={-1}
                  max={50}
                  name={name}
                  value={value}
                  onChange={onChange}
                  error={error}
                />
              )}
            />

            <Controller
              control={control}
              name="endingColorCount"
              rules={{ required: true }}
              render={({
                field: { onChange, value, name },
                fieldState: { error },
              }) => (
                <NumberInputFormControl
                  label="Ending Color Count"
                  placeholder="Ending Color Count"
                  required
                  min={-1}
                  max={50}
                  name={name}
                  value={value}
                  onChange={onChange}
                  error={error}
                />
              )}
            />

            <Controller
              control={control}
              name="runChargeType"
              rules={{ required: true }}
              render={({
                field: { onChange, value, name },
                fieldState: { error },
              }) => (
                <TextInputFormControl
                  label="Run Charge Type"
                  placeholder="Run Charge Type"
                  required
                  name={name}
                  value={value}
                  onChange={onChange}
                  error={error}
                />
              )}
            />
          </div>
        </div>
      </div>
      <hr />
      <div className="d-flex justify-content-center">
        <span
          className="btn btn-sm btn-danger mr-5"
          onClick={(e) => history.goBack()}
        >
          Cancel
        </span>
        <button type="submit" className="btn btn-sm btn-success">
          Save
        </button>
      </div>
    </form>
  );
}

export default ExceptionCategoryForm;
